import { render, staticRenderFns } from "./UserTypePermissions.vue?vue&type=template&id=0f5a0c93&"
import script from "./UserTypePermissions.vue?vue&type=script&lang=js&"
export * from "./UserTypePermissions.vue?vue&type=script&lang=js&"
import style0 from "./UserTypePermissions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports